import React, { useState, useEffect } from 'react';
import { documentService } from '../services/documentService';
import { SearchResultItem } from '../components/SearchResultItem';
import { DocumentPreviewModal } from '../components/DocumentPreviewModal';
import { Loader } from 'lucide-react';
import toast from 'react-hot-toast';

const Favorites: React.FC = () => {
    const [favorites, setFavorites] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [selectedDocument, setSelectedDocument] = useState<any>(null);

    // Load favorites on mount
    useEffect(() => {
        loadFavorites();
    }, []);

    const loadFavorites = async () => {
        try {
            setLoading(true);
            // The backend returns an array of objects: [{ id, document: {...}, created_at }, ...]
            const data = await documentService.getFavorites();
            setFavorites(data);
        } catch (error) {
            console.error('Failed to load favorites:', error);
            toast.error('Failed to load favorites');
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveFavorite = async (documentId: number) => {
        try {
            await documentService.removeFromFavorites(documentId);
            // Remove from local state immediately
            setFavorites(prev => prev.filter(item => item.document.id !== documentId));
            toast.success('Removed from favorites');
        } catch (error) {
            toast.error('Failed to remove favorite');
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                    My Favorites
                </h1>
                <span className="text-sm text-gray-500">
                    {favorites.length} saved documents
                </span>
            </div>

            {loading ? (
                <div className="flex justify-center py-12">
                    <Loader className="w-8 h-8 animate-spin text-blue-600" />
                </div>
            ) : favorites.length === 0 ? (
                <div className="text-center py-12 bg-white dark:bg-gray-800 rounded-lg shadow">
                    <p className="text-gray-500 dark:text-gray-400">
                        You haven't saved any documents yet.
                    </p>
                </div>
            ) : (
                <div className="grid gap-6">
                    {favorites.map((fav) => (
                        <div key={fav.id} className="relative group">
                            {/* Reuse SearchResultItem but wrap it to handle the 'document' structure mismatch if needed 
                   The backend returns { id: favId, document: { ...docData } }
               */}

                            <SearchResultItem
                                isFavorite={true}
                                onToggleFavorite={() => handleRemoveFavorite(fav.document.id)}
                                result={fav.document}
                                onPreview={() => setSelectedDocument(fav.document)}
                                onDownload={() => setSelectedDocument(fav.document)}
                            />
                        </div>
                    ))}
                </div>
            )}

            {selectedDocument && (
                <DocumentPreviewModal
                    document={selectedDocument}
                    isOpen={!!selectedDocument}
                    onClose={() => setSelectedDocument(null)} onDownload={function (document: any): void {
                        throw new Error('Function not implemented.');
                    }} />
            )}
        </div>
    );
};

export default Favorites;